import ApiClient from '@/libs/http-client'

const RolesService = {
    endpoints(route, param) {
        const url = {
            roles: '/api/roles',
            changeRole: `/api/roles/${param}`,
            roleAccesses: `/api/roles/accesses`,
        }
        return url[route]
    },
    get(url, param = {}) {
        return ApiClient.get(this.endpoints(url, param))
    },
    post(url, params = {}, data, config = {}) {
        return ApiClient.post(this.endpoints(url, params), data, config)
    },
    put(url, params = {}, data, config = {}) {
        return ApiClient.put(this.endpoints(url, params), data, config)
    },
    delete(url, params = {}, config = {}) {
        return ApiClient.delete(this.endpoints(url, params), config)
    },
}

export default RolesService
